// extracted by mini-css-extract-plugin
module.exports = {"logo":"Icons_logo__13zXJ","close":"Icons_close__3kTKK","arrow":"Icons_arrow__1h916","scrollUp":"Icons_scrollUp__I4u4b","scrollDown":"Icons_scrollDown__3wtqk"};